import * as React from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function CustomPagination({ totalCount, currentPage, onPageChange }) {
  return (
    <Stack spacing={2}>
      <Pagination
        count={totalCount} // Total number of pages
        page={currentPage} // Current active page
        onChange={(event, page) => onPageChange(page)} // Handle page change
        renderItem={(item) => (
          <PaginationItem slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }} {...item} />
        )}
      />
    </Stack>
  );
}
